class LoadMore extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.loadMoreItemsRetainPos.bind(this));
    this.updateProgressBar();
    this.retainScrollPositionClp();
  }

  retainScrollPositionClp() {
    const desiredPage = parseInt(sessionStorage.getItem('desiredPage'));
    const scrollPos = sessionStorage.getItem('scrollPos');

    if (desiredPage && scrollPos) {
      this.loadMoreItemsRetainPos(desiredPage, scrollPos);
    }

    window.addEventListener('beforeunload', function() {
      sessionStorage.setItem('scrollPos', window.scrollY);
    });
  }

  loadMoreItemsRetainPos(desiredPage, scrollPos) {
    const loadMoreBtn = this.querySelector('[type="button"]');
    loadMoreBtn.setAttribute("disabled", true);

    const { pageSize, nextUrl, totalItems } = this.dataset;
    let nextPage = parseInt(this.dataset.currentPage) + 1;
    sessionStorage.setItem('desiredPage', nextPage);

    const fetchNextPage = () => {
      fetch(nextUrl.replace(/page=[0-9]+/, 'page=' + nextPage))
        .then(response => response.text())
        .then(responseText => {
          const parser = new DOMParser();
          const html = parser.parseFromString(responseText, 'text/html');
          const items = html.querySelectorAll('#product-grid > .grid__item:not(.grid__item--banner)');

          items.forEach(item => {
            document.querySelector('#product-grid').appendChild(item);
          });

          // Re-initialize tippy tooltips for newly loaded items
          if (window.app && window.app.initTippy) {
            window.app.initTippy();
          }

          if (nextPage === desiredPage) {
            setTimeout(() => {
              window.scrollTo(0, scrollPos);
            }, 0);
          } else if (nextPage < desiredPage) {
            nextPage++;
            fetchNextPage();
          }
          this.dataset.currentPage = nextPage;

          this.updateProgressBar();
        })
        .catch(e => {
          console.error(e);
          loadMoreBtn.removeAttribute("disabled");
        })
        .finally(() => {
          loadMoreBtn.removeAttribute("disabled");

          let isLastPage = parseInt(totalItems) - nextPage * parseInt(pageSize) < 0;
          this.querySelector('[load-items-count]').innerHTML = isLastPage ? parseInt(totalItems) : nextPage * parseInt(pageSize);
          isLastPage && loadMoreBtn.setAttribute("disabled", true);
        });
    };

    fetchNextPage();
  }

  updateProgressBar() {
    const loadedItemsCount = document.querySelectorAll('.grid__item .product-card').length;
    const totalItemsCount = parseInt(this.dataset.totalItems);
    const progressBarFill = this.querySelector('.progress-bar__fill');
    const progressPercentage = (loadedItemsCount / totalItemsCount) * 100;

    progressBarFill.style.width = progressPercentage + '%';
  }
}

customElements.define('load-more', LoadMore);
